/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

import 'htmx.org'

import { debounce, isSafari } from 'marketing-ui/client'
import { getComplianceSettings, initConsent } from './consent.ts'
import { initConversions } from './conversions.ts'

async function hydrate() {
  console.log('[HYDRATE] Hydration starting')

  initConversions()

  if (isSafari()) {
    const { polyfillPopoverPlacements } = await import('marketing-ui/client')
    polyfillPopoverPlacements()
  }

  if (document.querySelector('.breadcrumbs__container')) {
    const { initBreadcrumbs } = await import('marketing-ui/client')
    initBreadcrumbs()
  }

  if (document.querySelector('dialog.drawer')) {
    const { initDrawers } = await import('marketing-ui/client')
    initDrawers()
  }

  if (document.querySelector('.header')) {
    const { initHeader } = await import('marketing-ui/client')
    initHeader()
  }

  if (document.querySelector('.icon__toggle')) {
    const { initIconToggles } = await import('marketing-ui/client')
    initIconToggles()
  }

  if (document.querySelector('.footer')) {
    const { initFooter } = await import('marketing-ui/client')
    initFooter()
  }

  if (document.querySelector('.product-detail')) {
    const { initProductDetail } = await import('marketing-ui/client')
    initProductDetail()
  }

  if (document.querySelector('.read-more__toggle')) {
    const { initReadMore } = await import('marketing-ui/client')
    initReadMore()
  }

  if (document.querySelector('.label__toggle')) {
    const { initLabelToggles } = await import('marketing-ui/client')
    initLabelToggles()
  }

  if (document.querySelector('.product-slider')) {
    const { initProductSlider } = await import('marketing-ui/client')
    initProductSlider()
  }

  if (document.querySelector('.video')) {
    const { initVideo } = await import('marketing-ui/client')
    initVideo()
  }

  if (document.querySelector('.form')) {
    const { initForms } = await import('marketing-ui/client')
    initForms()
  }

  if (document.querySelector('.content-slider')) {
    const { initContentSlider } = await import('marketing-ui/client')
    initContentSlider()
  }

  if (document.querySelector('.usp-slider')) {
    const { initUspSlider } = await import('marketing-ui/client')
    initUspSlider()
  }

  if (document.querySelector('[data-geolocation]')) {
    const { initGeolocation } = await import('./geolocation.ts')
    initGeolocation()
  }

  if (document.querySelector('.search')) {
    const { initSearches } = await import('marketing-ui/client')
    initSearches()
  }

  if (document.querySelector('.accordion')) {
    const { initAccordion } = await import('marketing-ui/client')
    initAccordion()
  }

  if (
    document.querySelector('.form[data-recaptcha="true"]') &&
    window.snx_piwik_compliance_settings?.consents?.custom_consent?.status === 1
  ) {
    document.querySelectorAll<HTMLFormElement>('.form[data-recaptcha="true"]')
      .forEach((form) => {
        form.parentNode?.querySelector('.gate')?.remove()
      })

    const { initRecaptcha } = await import('./forms.ts')
    initRecaptcha()
  }

  if (document.querySelector('.you-tube-embed')) {
    if (
      window.snx_piwik_compliance_settings?.consents?.analytics?.status === 1
    ) {
      const { initYouTubeEmbeds } = await import('marketing-ui/client')
      initYouTubeEmbeds()

      const gates = Array.from(
        document.querySelectorAll('.you-tube-embed .gate'),
      )
      gates.forEach((gate) => gate.remove())
    }
  }

  if (document.querySelector('.combobox')) {
    const { initCombobox } = await import('marketing-ui/client')
    initCombobox()
  }

  if (document.querySelector('a[href^="#jump-"]')) {
    const { initJumpLinks } = await import('marketing-ui/client')
    initJumpLinks()
  }

  if (document.querySelector('.file-input')) {
    const { initFileInputs } = await import('marketing-ui/client')
    initFileInputs()
  }

  if (document.querySelector('.checkbox-group')) {
    const { initCheckboxGroups } = await import('marketing-ui/client')
    initCheckboxGroups()
  }

  if (document.querySelector('.text-area')) {
    const { initTextAreas } = await import('marketing-ui/client')
    initTextAreas()
  }

  initConsent()

  window.dispatchEvent(new CustomEvent('hydrated'))
  console.log('[HYDRATE] Hydration complete')
}

hydrate()
getComplianceSettings(hydrate)

window.addEventListener(
  'hydrate',
  () => console.log('[HYDRATE] Manual hydration triggered'),
)
window.addEventListener('htmx:afterSwap', debounce(() => hydrate(), 100))
window.addEventListener('hydrate', debounce(() => hydrate(), 100))
